// Líneas LOST de la sesión en el vocabulario del aviso: nombre, motivo y si es la ancla.
import { catalogDisplayName } from '@/shared/lib/format/itemDisplayName';
import { anchorLineOf } from './buildSale';
import { lostLinesOf } from './integrationErrors';
import type { ReservedLine, WizardSession } from './types';

export interface LostLineView {
    lineId: string;
    name: string;
    lostReason: ReservedLine['lostReason'];
    /** La ancla (teléfono) se cambia en Producto; un extra solo se quita. */
    anchor: boolean;
}

export function lostLineViewsOf(
    session: WizardSession | undefined,
    descriptions: ReadonlyMap<string, string>,
): LostLineView[] {
    if (!session) return [];
    const anchorId = anchorLineOf(session)?.lineId;
    return lostLinesOf(session).map((l) => ({
        lineId: l.lineId,
        name: catalogDisplayName({ sku: l.sku, ...l.product }, descriptions),
        lostReason: l.lostReason,
        anchor: l.lineId === anchorId,
    }));
}
